module.exports = __webpack_public_path__ + "c6751d9047e3f7763761d4fdd6c1e2cf.jpg";